import PublisherActions from '../../../../actions/PublisherActions';
import GoalActions from '../../../../actions/GoalActions';
import RegionsActions from '../../../../actions/RegionsActions';
import store from '../../../../stores/redux';
import {
    getRegionIds
} from '../helpers';

const actions = {
    searchGoalEntries(offerId) {
        const params = { offer_ids: offerId };

        GoalActions.clear();

        PublisherActions.getGoalEntries(params, () => {
            const goalEntries = store.getState().goalEntries.list;

            if (!goalEntries || !Array.isArray(goalEntries) || goalEntries.length === 0) {
                return;
            }

            const goalIds = _getGoalIds(goalEntries);
            const regionIds = getRegionIds(goalEntries);

            if (goalIds && typeof goalIds === 'string' && goalIds.trim() && goalIds.length > 0) {
                const validGoalIds = goalIds.split(',').filter(id => {
                    const trimmedId = id && id.trim();
                    return trimmedId && trimmedId.length > 0 && !isNaN(trimmedId) && parseInt(trimmedId) > 0;
                });

                if (validGoalIds.length > 0) {
                    GoalActions.getListGoalActions({goal_ids: validGoalIds.join(',')});
                }
            }

            regionIds && RegionsActions.searchRegions({ids: regionIds});
        });
    }
};

const _getGoalIds = (goalEntries) => {
    if (!goalEntries || !Array.isArray(goalEntries) || goalEntries.length === 0) {
        return '';
    }

    const ids = goalEntries
        .filter(g => g && g.goal && g.goal.id !== undefined && g.goal.id !== null && g.goal.id !== '')
        .map(g => String(g.goal.id).trim())
        .filter(id => id.length > 0 && !isNaN(id) && parseInt(id) > 0);

    return ids.join(',');
};

export default actions;
